import React from "react";

// Reusable status badge with color dot
export function StatusBadge({ status, statuses }) {
  const s = statuses?.find((x) => x.key === status) || { key: status, label: status, color: "#6B6862" };
  return (
    <span
      className="inline-flex items-center gap-2 px-2 py-1 text-[10px] tracking-[0.18em] uppercase font-medium border border-[#262626] bg-[#0A0A0A]"
      style={{ color: s.color }}
      data-testid={`status-${s.key}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}

export function StatusPill({ status, statuses }) {
  const s = statuses?.find((x) => x.key === status) || { label: status, color: "#6B6862" };
  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 text-[10px] tracking-wider uppercase font-semibold rounded-sm"
      style={{ background: s.color, color: ["#FFFFFF", "#84CC16", "#F59E0B", "#A8A29E"].includes(s.color) ? "#050505" : "#FFFFFF" }}
    >
      {s.label}
    </span>
  );
}

// Shown in place of the status badge once an actor holds a role assignment.
export function RoleAssignedBadge() {
  return (
    <span
      data-testid="status-role-assigned"
      className="inline-flex items-center gap-2 px-2 py-1 text-[10px] tracking-[0.18em] uppercase font-medium border border-[#10B981]/50 bg-[#10B981]/10 text-[#10B981]"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />
      Role Assigned
    </span>
  );
}

// Update 27 Change 06: shown when an actor has declined/rejected their role offer.
export function RoleRejectedBadge() {
  return (
    <span
      data-testid="status-role-rejected"
      className="inline-flex items-center gap-2 px-2 py-1 text-[10px] tracking-[0.18em] uppercase font-medium border border-blood/50 bg-blood/10 text-blood"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-blood" />
      Role Rejected
    </span>
  );
}
